export default "__VITE_ASSET__CxCJLDLJ__"